<template>
  <div id="ranking-board">
    <module-title title="时段销售趋势" />
    <div id="myChart" style="width: 100%; height: 80%;"></div>
  </div>
</template>

<script>
import ModuleTitle from '../Common/ModuleTitle.vue';
export default {
  name: 'TimesChart',
  components: {
    ModuleTitle
  },
  props: {
    timesData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null, // 用于存储 ECharts 实例
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['今日', '昨日'],
          textStyle: { color: '#ffffff' },
          left: 'right',
          // align:'right',
          icon: 'pin',
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: {
              color: '#FFFFFF' // 设置 X 轴文字颜色为白色
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: '#ffffff',
                width: 1,
                type: 'dashed',
                opacity: 0.2
              },
              // splitNumber: 1 // 设置分隔线数量为 1

            },
            axisLabel: {
              color: '#FFFFFF' // 设置 Y 轴文字颜色为白色
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#ffffff', // 竖线颜色
                width: 1 // 竖线宽度
              }
            }
          }
        ],
        series: [
          {
            name: '昨日',
            type: 'line',
            smooth: true,
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(20,216,93,0.8)' }, // 起始颜色
                  { offset: 1, color: 'rgba(20,216,93,0.0)' }  // 结束颜色
                ]
              )
            },
            emphasis: {
              focus: 'series'
            },
            lineStyle: {
              color: '#14D85D'
            },
            data: []
          },
          {
            name: '今日',
            type: 'line',
            smooth: true,
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: 'rgba(0,136,240,0.8)' }, // 起始颜色
                  { offset: 1, color: 'rgba(0,136,240,0.0)' }  // 结束颜色
                ]
              )
              // linear-gradient(180deg,#0088f0, rgba(0,136,240,0.00));
            },
            lineStyle: {
              color: 'rgba(0,136,240)'
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
        ]
      }
    };
  },
  mounted() {
    const hours24 = Array.from({ length: 24 }, (_, i) => {
      return i < 10 ? `0${i}:00` : `${i}:00`;
    });
    this.options.xAxis[0].data = hours24;
    // 初始化 ECharts 实例
    this.chart = this.$echarts.init(document.getElementById('myChart')); // 如果你选择了全局引入
    // 使用配置项和数据显示图表
    this.chart.setOption(this.options);
  },
  watch: {
    timesData: {
      handler(newVal) {
        this.setData(newVal);
      },
      deep: true
    }
  },
  methods: {
    setData(data) {
      //获取当前小时 两位
      let currentHour = new Date().getHours();
      currentHour = currentHour < 10 ? `0${currentHour}` : currentHour;
      currentHour = `${currentHour}:00`;

      // 今日数据
      let todayData = [];
      // 昨日数据
      let yesterdayData = [];

      this.options.xAxis[0].data.forEach((item) => {
        // 今日数据
        //查找当前小时 今日数据
        let todayDataItem = data.Current.find(t => t.Time === item);
        if (todayDataItem != undefined) {
          todayData.push(todayDataItem.SaleAmount);
        } else {
          todayData.push(0);
        }
        // 昨日数据
        let yesterdayDataItem = data.Cycle.find(t => t.Time === item);
        if (yesterdayDataItem != undefined) {
          yesterdayData.push(yesterdayDataItem.SaleAmount);
        } else {
          yesterdayData.push(0);
        }

      })
      // 今日数据 到 当前小时 数据
      let todayDataToCurrentHour = todayData.slice(0, this.options.xAxis[0].data.indexOf(currentHour) + 1);
      console.log('currentHour', todayData);

      this.options.series[0].data = yesterdayData;
      this.options.series[1].data = todayDataToCurrentHour;
      this.chart.setOption(this.options);
      // 昨日数据 到 当前小时 数据
      //let yesterdayDataToCurrentHour = yesterdayData.slice(0, yesterdayData.indexOf(currentHour) + 1);
      // this.options.series[0].data = data[0];
      // this.chart.setOption(this.options);

    }
  }
}
</script>

<style lang="less" scoped>
#ranking-board {
  height: 100%;
  width: 100%;
  background: rgba(24, 50, 148, 0.30);
  border: 1px solid;
  border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
  border-radius: 8px;
  // margin-bottom: 20px;

}
</style>
